import { forwardRef } from 'react';

const CheckboxField = forwardRef(
    ({ label, name, error, disableTab, hint, className = '', ...props }, ref) => {
        const errorId = `${name}-error`;

        return (
            <div
                className={`form-group form-group--checkbox ${error ? 'has-error' : ''} ${className}`}
            >
                <label className="checkbox-field">
                    <input
                        ref={ref}
                        id={name}
                        name={name}
                        type="checkbox"
                        tabIndex={disableTab ? -1 : 0}
                        aria-invalid={!!error}
                        aria-describedby={error ? errorId : undefined}
                        {...props}
                    />
                    <span className="checkbox-field__label">{label}</span>
                </label>

                {hint && <span className="field-hint">{hint}</span>}
                {error && (
                    <span id={errorId} className="checkbox-field__error" role="alert">
                        {error.message}
                    </span>
                )}
            </div>
        );
    }
);

CheckboxField.displayName = 'CheckboxField';
export default CheckboxField;
